declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

export function initMetaPixel(pixelId: string) {
  if (initialized) return
  initialized = true

  // Meta Pixel base code
  const f = window
  const b = document
  const n = (f.fbq = function (...args: any[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod.apply(n, args)
    } else {
      ;(n as any).queue.push(args)
    }
  })
  if (!f._fbq) f._fbq = n
  ;(n as any).push = n
  ;(n as any).loaded = true
  ;(n as any).version = '2.0'
  ;(n as any).queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  b.head.appendChild(t)

  window.fbq('init', pixelId)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Potencia 21',
      content_type: 'product',
      value: 6.49,
      currency: 'USD',
    })
  }
}
